import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon, FloatingLabelInput, SquareBorderButton } from '@lyearn-team/frontend-components';
import AccordionItems from './AccordionItems';
import utils from '../../../../utils/utils';

class AccordionSettings extends Component {
  static contextTypes = {
    dispatch: PropTypes.func
  };
  // componentDidMount() {
  //   executeHelper();
  // }

  onHeadingChange = (itemId, index) => (e) => {
    this.context.dispatch('UPDATE_ITEM_DATA', {
      _id: itemId,
      heading: e.target.value
    });
  };

  addNewItem = index => () => {
    const id = this.props.blockItem._id;
    const items = this.props.blockItem.items;
    const newItem = {
      _id: utils.getNewObjectId(),
      heading: 'Add New Title ' + (index + 1),
      html:
        "<p>Infuse your life with action. Don't wait for it to happen. Make it happen. Make your own future. Make your own hope. Make your own love. And whatever your beliefs, honor your creator, not by passively waiting for grace to come down from upon high, but by doing what you can to make grace happen... yourself, right now, right down here on Earth.</p>"
    };

    items.splice(index, 0, newItem);
    const newItems = items;

    this.context.dispatch('UPDATE_ITEM_DATA', {
      id,
      ...this.props.blockItem,
      items: newItems
    });
  };

  removeItem = index => () => {
    const id = this.props.blockItem._id;
    const items = this.props.blockItem.items;
    items.splice(index, 1);
    const newItems = items;

    this.context.dispatch('UPDATE_ITEM_DATA', {
      id,
      ...this.props.blockItem,
      items: newItems
    });
  };

  renderHeading(item, index) {
    const heading = item.heading;
    return (
      <FloatingLabelInput
        onChange={this.onHeadingChange(item._id, index, this.context.dispatch)}
        value={heading}
        placeholder="Add a Title"
        label="Title"
        style={{ fontFamily: 'ProximaNova', fontSize: '16px' }}
      />
    );
  }

  render() {
    const items = this.props.blockItem.items;
    const numberofItems = this.props.blockItem.items.length;

    return (
      <div>
        {items.map((item, index) => (
          <div key={index}>
            <div className="block-edit-field-drag-item">
              <div className="block-edit-field-drag-item__container">
                <div className="block-edit-field-drag-item__content">
                  <div style={{ width: '100%' }}>
                    <div
                      className="block-edit-field block-edit-field--no-padding"
                      style={{ fontFamily: 'ProximaNova', fontSize: '16px' }}
                    >
                      <div>
                        <div style={{ width: 'auto' }} className="block-edit-label-lyearn">
                          Item
                          {' '}
                          {index + 1}
                          {' '}
                        </div>

                        {numberofItems > 1 ? (
                          <div
                            style={{ float: 'right', marginTop: '-35px', marginRight: '-12px' }}
                            onClick={this.removeItem(index)}
                            role="button"
                            tabIndex="-1"
                          >
                            <div className="block-edit-delete-button__icon">
                              <Icon type="delete" size="15px" />
                            </div>
                          </div>
                        ) : (
                          ''
                        )}
                      </div>
                    </div>

                    <div className="block-edit-field">
                      <div className="brand--linkColor" style={{ fontFamily: 'ProximaNova' }}>
                        {this.renderHeading(item, index)}
                      </div>
                      <AccordionItems item={item} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
        <div className="block-edit-field-upload brand--ui">
          <div className="block-edit-field-upload__inner">
            <SquareBorderButton
              text="+ Add Item"
              type="bordered"
              status="normal"
              onClick={this.addNewItem(numberofItems)}
              style={{
                width: '450px',
                height: '44px',
                borderRadius: '2px',
                fontFamily: 'ProximaNova',
                fontSize: '16px'
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default AccordionSettings;
